import Head from 'next/head';

import { serialize } from 'next-mdx-remote/serialize';

import PageWrapper from 'components/PageWrapper';
import StaticPage from 'components/StaticPage';
import XPage from 'components/XPage';
import LandingPage from 'components/LandingPage';
import { isProduction } from 'utils/helpers';
import { getLocations } from 'utils/graphcms/queries/locations';

import {
  getStaticPage,
  getStaticPages,
} from 'utils/graphcms/queries/staticPage';
import { getAllXSlugs, getXPage } from 'utils/graphcms/queries/xPage';
import { getLandingPage } from 'utils/graphcms/queries/landingPage';

export default function Page({ page, template, venues }) {
  if (template === 'static') {
    return (
      <PageWrapper page={page}>
        <StaticPage page={page} />
      </PageWrapper>
    );
  }
  if (template === 'x') {
    return (
      <PageWrapper page={page}>
        <XPage page={page} venues={venues} />
      </PageWrapper>
    );
  }
  if (template === 'landing') {
    return (
      <>
        {isProduction() && (
          <Head>
            <meta
              name="facebook-domain-verification"
              content="vfpztrvrax0ufkkx0ur2avjlg47nfp"
            />
          </Head>
        )}

        <PageWrapper page={page}>
          <LandingPage page={page} />
        </PageWrapper>
      </>
    );
  }

  return null;
}

export async function getStaticProps({ params }) {
  const slug = Array.isArray(params.slug) ? params.slug.join('/') : params.slug;

  try {
    const data = await getStaticPage(slug);
    return {
      props: {
        template: 'static',
        page: {
          markdown: data.content ? await serialize(data.content) : null,
          ...data,
        },
      },
    };
  } catch (error) {
    console.info('No static page found, trying X page...');
  }
  try {
    const data = await getXPage(slug);
    if (data) {
      return {
        props: {
          template: 'x',
          page: data.x,
          venues: data.venues || null,
        },
        revalidate: 10,
      };
    }
  } catch (error) {
    console.info('No X page found, trying landing page...');
  }
  try {
    const data = await getLandingPage(slug);
    return {
      props: {
        template: 'landing',
        page: data,
      },
    };
  } catch (error) {
    console.info('No landing page found, 404...');
  }

  return {
    notFound: true,
  };
}

export async function getStaticPaths() {
  const slugs = (
    await Promise.all([
      getStaticPages(),
      getAllXSlugs().then((xes) => xes.map((x) => x.slug)),
      getLocations(),
    ])
  ).flat();
  return {
    paths: slugs.map((slug) => ({ params: { slug: slug.split('/') } })),
    fallback: false,
  };
}
